import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { session } = useAuth();

  const handleConsultationClick = () => {
    navigate('/consultation');
    setIsMenuOpen(false);
  };

  const handleNavigation = (path: string) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-lg z-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="cursor-pointer">
            <video
              src="/assets/logo.gif.mp4"
              className="h-14 w-auto"
              autoPlay
              loop
              muted
              playsInline
              aria-label="Homepage"
            />
          </Link>

          <nav className="hidden lg:flex items-center space-x-5">
            <Link to="/" className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">Home</Link>
            <Link to="/about" className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">About Us</Link>
            <Link to="/courses" className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">Courses</Link>
            <Link to="/colleges" className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">Colleges</Link>
            <Link to="/events" className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">Events</Link>
            <Link to="/delegate-meetings" className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">Delegate Meetings</Link>
            <Link to="/services" className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">Services</Link>
            <Link to="/blog" className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">Blog</Link>
            <Link to="/contact" className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">Contact</Link>
            {session && <Link to="/admin" className="text-red-500 hover:text-red-700 font-bold transition-colors duration-200">Admin</Link>}
          </nav>

          <div className="hidden lg:flex items-center">
            <button
              onClick={handleConsultationClick}
              className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-3 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-line text-lg"></i>
              Free Consultation
            </button>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-gray-700 hover:text-blue-600 cursor-pointer"
          >
            <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="lg-hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t z-50">
            <div className="px-6 py-4 space-y-4">
              <button onClick={() => handleNavigation('/')} className="block w-full text-left text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">Home</button>
              <button onClick={() => handleNavigation('/about')} className="block w-full text-left text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">About Us</button>
              <button onClick={() => handleNavigation('/courses')} className="block w-full text-left text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">Courses</button>
              <button onClick={() => handleNavigation('/colleges')} className="block w-full text-left text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">Colleges</button>
              <button onClick={() => handleNavigation('/events')} className="block w-full text-left text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">Events</button>
              <button onClick={() => handleNavigation('/delegate-meetings')} className="block w-full text-left text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">Delegate Meetings</button>
              <button onClick={() => handleNavigation('/services')} className="block w-full text-left text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">Services</button>
               <button onClick={() => handleNavigation('/blog')} className="block w-full text-left text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">Blog</button>
              <button onClick={() => handleNavigation('/contact')} className="block w-full text-left text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">Contact</button>
              {session && <button onClick={() => handleNavigation('/admin')} className="block w-full text-left text-red-500 hover:text-red-700 font-bold transition-colors duration-200">Admin Dashboard</button>}
              <button onClick={handleConsultationClick} className="block w-full bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-3 rounded-full transition-all duration-300 text-center whitespace-nowrap cursor-pointer">
                <i className="ri-calendar-line mr-2"></i>
                Free Consultation
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
